import React from 'react'
import styled from 'styled-components'
import { Transition } from 'react-transition-group'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { Icon } from '@navent-jobs/ui-kit/components/icon'
import { AnimationFixed } from '@navent-jobs/ui-kit/components/animation'

interface SidebarState {
  position: string
  children: any
  visible: boolean
}

const initialSidebarState: SidebarState = {
  position: 'left',
  children: null,
  visible: false,
}

const SidebarComponent = styled.div`
  position: relative;
  background-color: white;
  width: 100%;
  height: 100%;
  pointer-events: auto;
  ${props => (props.closeType === 'back' ? 'padding: 56px 0 0;' : ``)}
`

const CloseButton = styled.button`
  border: 0px;
  margin: 0px;
  padding: 0px;
  background: none;
  box-shadow: none;
  outline: none;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
`

const BackArrow = styled.button`
  border: 0px;
  margin: 0px;
  padding: 0px;
  background: none;
  box-shadow: none;
  outline: none;
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 100;
`

export const Sidebar = ({ position, children, visible, handleClose, closeType }) => {
  const animation = position === 'left' ? 'fadeInSlideLeft' : 'fadeInSlideRight'
  const { isDesktop, isTabletLandscape } = useWindowSize()
  const isDesktopOrTabletLandscape = isDesktop || isTabletLandscape

  return (
    <Transition in={visible} timeout={300}>
      {state => (
        <AnimationFixed
          name={animation}
          isDesktop={isDesktopOrTabletLandscape}
          position={position}
          className={`animation-${state}`}
          duration=".5"
        >
          <SidebarComponent closeType={closeType}>
            {closeType === 'close' && (
              <CloseButton type="button" onClick={handleClose}>
                <Icon name="icon-light-close" color="rgba(0, 0, 24, 0.84);" size="24" />
              </CloseButton>
            )}

            {(closeType === 'back' || closeType === 'backFilter') && (
              <BackArrow type="button" onClick={handleClose}>
                <Icon name="icon-light-arrow-left" color="rgba(0, 0, 24, 0.84);" size="24" />
              </BackArrow>
            )}

            {children}
          </SidebarComponent>
        </AnimationFixed>
      )}
    </Transition>
  )
}
